import { ArrowDown, ArrowDownUp, ArrowUp, ArrowUpDown } from 'lucide-react';
import { Button } from '../button';
import { Column } from '@tanstack/react-table';

type ColumnButtonSortProps = {
  label: string;
  column: Column<any>;
};

const ColumnButtonSort = ({ label, column }: ColumnButtonSortProps) => {
  return (
    <Button
      variant="ghost"
      onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
    >
      {label}
      {column.getIsSorted() === 'asc' ? (
        <ArrowUp className="ml-2 h-4 w-4" />
      ) : column.getIsSorted() === 'desc' ? (
        <ArrowDown className="ml-2 h-4 w-4" />
      ) : (
        <ArrowUpDown className="ml-2 h-4 w-4" />
      )}
    </Button>
  );
};

export default ColumnButtonSort;
